var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMinus = function SvgMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 42"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2537"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M8 0h32v42H8a8 8 0 0 1-8-8V8a8 8 0 0 1 8-8",
    "data-name": "Rectangle 1849"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13 22v-2h14v2Z",
    "data-name": "Path 2484"
  }))));
};
export default SvgMinus;